// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/check.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/check'

import { Icon, type IconComponentProps } from '../icon'

export const CheckIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
